/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdatePluginForm,
  UpdatePluginForm$Outbound,
  UpdatePluginForm$outboundSchema,
} from "../components/updatepluginform.js";

export type UpdatePluginSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type UpdatePluginRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  updatePluginForm: UpdatePluginForm;
};

/** @internal */
export type UpdatePluginSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const UpdatePluginSecurity$outboundSchema: z.ZodMiniType<
  UpdatePluginSecurity$Outbound,
  UpdatePluginSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function updatePluginSecurityToJSON(
  updatePluginSecurity: UpdatePluginSecurity,
): string {
  return JSON.stringify(
    UpdatePluginSecurity$outboundSchema.parse(updatePluginSecurity),
  );
}

/** @internal */
export type UpdatePluginRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  UpdatePluginForm: UpdatePluginForm$Outbound;
};

/** @internal */
export const UpdatePluginRequest$outboundSchema: z.ZodMiniType<
  UpdatePluginRequest$Outbound,
  UpdatePluginRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    updatePluginForm: UpdatePluginForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      updatePluginForm: "UpdatePluginForm",
    });
  }),
);

export function updatePluginRequestToJSON(
  updatePluginRequest: UpdatePluginRequest,
): string {
  return JSON.stringify(
    UpdatePluginRequest$outboundSchema.parse(updatePluginRequest),
  );
}
